import React from 'react';
import { TableRow, TableCell, Box } from '@mui/material';
import TaxbillStaticTableCell from './TaxbillStaticTableCell';

const TaxbillStaticsTeamRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        hq?.children &&
        hq?.children.map((dp, dpIndex) => {
          return (
            <TableRow key={dp.id}>
              {dpIndex === 0 && dp.id !== 'total' && (
                <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                  {hq.name}
                </TableCell>
              )}
              <TableCell
                sx={{ width: '110px' }}
                align={dp.id === 'total' ? 'right' : 'left'}
                colSpan={dp.id === 'total' ? 2 : 1}
              >
                {dp.name}
              </TableCell>
              <TaxbillStaticTableCell data={dp} headerRows={headers} />
            </TableRow>
          );
        })
      );
    })
  );
};

export default TaxbillStaticsTeamRow;
